module.exports = __webpack_public_path__ + "img/2_116.cb7a73b1.png";